import { render, staticRenderFns } from "./AppHeaderBrandContact.vue?vue&type=template&id=3fe75810&"
import script from "./AppHeaderBrandContact.vue?vue&type=script&lang=js&"
export * from "./AppHeaderBrandContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports